export default __webpack_public_path__ + "static/media/facebook-icon.255a0b38.svg";